import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  IconButton,
  Divider,
  Chip,
  TextField,
  CircularProgress,
  Button,
} from "@mui/material";
import { GiSpades } from "react-icons/gi";
import { useNavigate } from "react-router-dom";
import {
  MdEdit,
  MdBusiness,
  MdEmail,
  MdPhone,
  MdCategory,
  MdPerson,
  MdLink,
  MdOutlineCalendarToday,
  MdOutlineUpdate,
} from "react-icons/md";
import { FaIndustry, FaGlobe, FaMoneyBillWave, FaUser } from "react-icons/fa";
import { RiUserStarFill } from "react-icons/ri";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import config from "../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const baseUrl = config.baseURL;

const Advertiser = () => {
  const [isAdvertiser, setIsAdvertiser] = useState(false);
  const [advertiserData, setAdvertiserData] = useState(null);
  const [companyData, setCompanyData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [profileData, setProfileData] = useState(null);
  const [editing, setEditing] = useState(false);
  const [userId, setUserId] = useState(null);
  const [companyId, setCompanyId] = useState(null);
  const [form, setForm] = useState({
    company_id: "",
    contact_person: "",
    contact_email: "",
    phone_number: "",
    business_industry: "",
    business_category: "",
    target_industries: "",
    target_categories: "",
    account_balance: 0,
  });
  const navigate = useNavigate();
  const [error, setError] = useState("");

  const token = localStorage.getItem("token");

  // Fetch advertiser and company info
  useEffect(() => {
    const fetchData = async () => {
      try {
        const decoded = jwtDecode(token);
        const userId = decoded.userId; // ✅ from JWT

        setUserId(userId);
        setCompanyId(decoded.companyId);
        setIsAdvertiser(decoded.isAdvertiser);
        console.log("🔑 Decoded JWT:", decoded);

        // ✅ Try to fetch advertiser using saved ID
        const advertiserId = decoded.advertiserId;
        console.log("advertiserId", advertiserId);
        if (advertiserId) {
          const res = await axios.get(
            `${baseUrl}/api/advertiser/${advertiserId}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );

          setAdvertiserData(res.data);
          setIsAdvertiser(true);
        }
        console.log("setAdvertiserData", res);
        // ✅ 2. Fetch company info (NEW token-based endpoint)
        const companyRes = await axios.get(`${baseUrl}/api/company`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        console.log("🏢 Company response:", companyRes.data);
        // ✅ 3. Fetch profile info
        const profileRes = await axios.get(`${baseUrl}/api/profile`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log("profileRes", profileRes.data);
        if (profileRes.data.is_advertiser) {
          setIsAdvertiser(true);
          setAdvertiserData(profileRes.data[0]);
        }
        if (companyRes.data) {
          setCompanyData(companyRes.data);
          setForm((prev) => {
            const updatedForm = {
              ...prev,
              company_id: companyRes.data.id,
              contact_email: profileRes.data?.email || "",
              contact_person: `${profileRes.data?.firstName || ""} ${
                profileRes.data?.lastName || ""
              }`.trim(),
              phone_number:
                profileRes.data?.phone || companyRes.data.phone || "",
              business_industry: companyRes.data.business_industry || "",
              business_category: companyRes.data.business_category || "",
            };

            console.log("📝 Updated form data:", updatedForm);
            return updatedForm;
          });
        }

        console.log("👤 Profile response:", profileRes.data);

        if (profileRes.data) {
          setProfileData(profileRes.data);
        }
      } catch (err) {
        console.error("❌ Error in fetchData:", err);
      } finally {
        setLoading(false);
        console.log("✅ Finished fetching all data");
      }
    };

    if (token) {
      fetchData();
    }
  }, [token]);
  useEffect(() => {
    console.log("advertiserData   s", advertiserData);
    if (advertiserData) {
      setForm({
        company_id: advertiserData.company_id || "",
        contact_person: advertiserData.contact_person || "",
        contact_email: advertiserData.contact_email || "",
        phone_number: advertiserData.phone_number || "",
        business_industry: advertiserData.business_industry || "",
        business_category: advertiserData.business_category || "",
        target_industries: advertiserData.target_industries?.join(", ") || "",
        target_categories: advertiserData.target_categories?.join(", ") || "",
        account_balance: advertiserData.account_balance || 0,
      });
    }
  }, [advertiserData, editing]);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    setError("");

    try {
      // Prepare fields to send (always the same for create/update)
      const payload = {
        target_industries: form.target_industries
          .split(",")
          .map((i) => i.trim()),
        target_categories: form.target_categories
          .split(",")
          .map((c) => c.trim()),
      };

      let res;
      console.log("editing", editing);
      if (editing) {
        // --- EDIT mode ---
        res = await axios.put(
          `${baseUrl}/api/advertiser/${advertiserData.id}`,
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        console.log("Advertiser updated:", res.data);

        // Update local advertiser data
        setAdvertiserData((prev) => ({ ...prev, ...payload }));
      } else {
        console.log("payload", payload);
        console.log("userId", userId);
        console.log("companyId", companyId);
        // --- CREATE mode ---
        const createPayload = {
          user_id: userId,
          company_id: companyId, // must be set in form
          ...payload,
        };

        res = await axios.post(`${baseUrl}/api/advertiser`, createPayload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log("Advertiser created:", res.data);
        // Save ID locally

        // Fetch advertiser data
        const advertiserRes = await axios.get(
          `${baseUrl}/api/advertiser/${res.data.advertiserId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        setAdvertiserData(advertiserRes.data);
        setIsAdvertiser(true);
      }

      // Exit edit mode
      setEditing(false);

      // Update form with latest values
      setForm((prev) => ({ ...prev, ...payload }));
    } catch (err) {
      console.error("Submit error:", err);
      const message =
        err.response?.data?.error ||
        err.response?.data?.message ||
        err.message ||
        "Server error";
      setError(message);
    }
  };

  const handleCharge = async () => {
    try {
      console.log("Charge button clicked!");
      toast.info("Charge functionality is not implemented yet.");
      const res = await axios.post(
        `${baseUrl}/api/stripe/create-checkout`,
        {
          user_id: userData.id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      window.location.href = res.data.url; // Redirect to Stripe Checkout
    } catch (err) {
      console.error("❌ Stripe checkout error:", err);
    }
  };

  if (loading)
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "#D1D8E0",
        }}
      >
        <CircularProgress />
      </Box>
    );
  if (isAdvertiser && advertiserData && !editing) {
    // --- DASHBOARD VIEW ---
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          padding: 4,
          backgroundColor: "#F4F6F8",
          minHeight: "100vh",
          fontFamily: "Poppins, sans-serif",
        }}
      >
        <Box
          sx={{
            maxWidth: 700,
            width: "100%",
            backgroundColor: "#fff",
            p: 4,
            borderRadius: 3,
            boxShadow: "0 6px 18px rgba(0,0,0,0.1)",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                fontWeight: "bold",
                color: "#2E4053",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <GiSpades color="#EA6A12" size={34} /> Advertiser Dashboard
            </Typography>
            <IconButton onClick={() => setEditing(true)}>
              <MdEdit size={26} color="#2E4053" />
            </IconButton>
            {/* --- Go to Ads Page Button --- */}
            {isAdvertiser && (
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  variant="contained"
                  startIcon={<GiSpades />}
                  onClick={() => navigate("/dashboard/Advertiser/ads")}
                  sx={{
                    backgroundColor: "#EA6A12",
                    "&:hover": { backgroundColor: "#c7570f" },
                    fontWeight: "bold",
                    textTransform: "none",
                  }}
                >
                  Manage Ads
                </Button>
              </Box>
            )}
          </Box>

          {/* Company Logo */}
          {companyData?.logo && (
            <Box sx={{ textAlign: "center", mb: 3 }}>
              <img
                src={companyData?.logo}
                alt="Company Logo"
                style={{ maxHeight: "100px", borderRadius: "8px" }}
              />
            </Box>
          )}

          {/* Contact Info */}
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: "600", color: "#1C2A3D", mb: 1 }}
            >
              Company Profile
            </Typography>
            <Divider sx={{ mb: 2 }} />

            <Box sx={{ display: "flex", alignItems: "center", mb: 1, gap: 1 }}>
              <MdPerson color="#2E4053" size={20} />
              <Typography>
                <strong>Contact Person:</strong>{" "}
                {advertiserData?.contact_person}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", mb: 1, gap: 1 }}>
              <MdEmail color="#2E4053" size={20} />
              <Typography>
                <strong>Email:</strong> {advertiserData?.contact_email}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", mb: 1, gap: 1 }}>
              <MdPhone color="#2E4053" size={20} />
              <Typography>
                <strong>Phone:</strong> {advertiserData?.phone_number}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", mb: 1, gap: 1 }}>
              <FaIndustry color="#2E4053" size={20} />
              <Typography>
                <strong>Industry:</strong> {advertiserData?.business_industry}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", mb: 1, gap: 1 }}>
              <MdCategory color="#2E4053" size={20} />
              <Typography>
                <strong>Category:</strong> {advertiserData?.business_category}
              </Typography>
            </Box>
          </Box>

          {/* Target Industries */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" sx={{ fontWeight: "600", mb: 1 }}>
              🎯 Target Industries
            </Typography>
            <Divider sx={{ mb: 2 }} />
            {advertiserData?.target_industries?.map((industry, idx) => (
              <Chip
                key={idx}
                label={industry}
                sx={{ mr: 1, mb: 1, backgroundColor: "#F0F4FF" }}
              />
            ))}
          </Box>

          {/* Target Categories */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" sx={{ fontWeight: "600", mb: 1 }}>
              📂 Target Categories
            </Typography>
            <Divider sx={{ mb: 2 }} />
            {advertiserData?.target_categories?.map((category, idx) => (
              <Chip
                key={idx}
                label={category}
                sx={{ mr: 1, mb: 1, backgroundColor: "#FFEFD5" }}
              />
            ))}
          </Box>

          {/* Balance */}
          <Box
            sx={{
              mt: 2,
              p: 2,
              backgroundColor: "#F0F4FF",
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "#2E4053",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <FaMoneyBillWave /> Account Balance
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Chip
                label={`$${advertiserData?.account_balance}`}
                color="primary"
                sx={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  backgroundColor: "#EA6A12",
                  color: "#fff",
                  px: 2,
                  py: 1,
                }}
              />
              <Button
                variant="contained"
                color="secondary"
                onClick={handleCharge}
                sx={{ fontWeight: "bold" }}
              >
                Charge
              </Button>
            </Box>
          </Box>

          {/* Dates */}
          <Box sx={{ mt: 3 }}>
            <Typography variant="body2" color="text.secondary">
              Created At:{" "}
              {new Date(advertiserData?.created_at).toLocaleString()}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Updated At:{" "}
              {new Date(advertiserData?.updated_at).toLocaleString()}
            </Typography>
          </Box>
        </Box>
      </Box>
    );
  }

  // --- FORM MODE (new advertiser OR editing) ---
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        padding: 4,
        backgroundColor: "#D1D8E0",
        minHeight: "100vh",
        fontFamily: "Poppins, sans-serif",
      }}
    >
      <Box
        sx={{
          maxWidth: 600,
          width: "100%",
          backgroundColor: "#fff",
          p: 4,
          borderRadius: 2,
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        <Typography
          variant="h4"
          sx={{ fontWeight: "bold", color: "#2E4053", mb: 3 }}
        >
          <GiSpades color="#2E4053" size={30} />{" "}
          {isAdvertiser ? "Edit Advertiser" : "Become an Advertiser"}
        </Typography>

        {/* Always read-only */}
        {/* Company Logo */}
        {companyData?.logo && (
          <Box sx={{ textAlign: "center", mb: 3 }}>
            <img
              src={companyData?.logo}
              alt="Company Logo"
              style={{ maxHeight: "100px", borderRadius: "8px" }}
            />
          </Box>
        )}

        {/* Contact Info (always read-only) */}
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="h6"
            sx={{ fontWeight: "600", color: "#1C2A3D", mb: 1 }}
          >
            Company Profile
          </Typography>
          <Divider sx={{ mb: 2 }} />

          <Box sx={{ display: "flex", alignItems: "center", mb: 1, gap: 1 }}>
            <MdPerson color="#2E4053" size={20} />
            <Typography>
              <strong>Contact Person:</strong>{" "}
              {`${profileData?.firstName || ""} ${
                profileData?.lastName || ""
              }`.trim() || "—"}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", mb: 1, gap: 1 }}>
            <MdEmail color="#2E4053" size={20} />
            <Typography>
              <strong>Email:</strong> {profileData?.email}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", mb: 1, gap: 1 }}>
            <MdPhone color="#2E4053" size={20} />
            <Typography>
              <strong>Phone:</strong> {profileData?.phone}
            </Typography>
          </Box>
        </Box>

        {/* Business Industry */}
        <Box sx={{ display: "flex", alignItems: "center", mb: 1, gap: 1 }}>
          <FaIndustry color="#2E4053" size={20} />
          <Typography>
            <strong>Industry:</strong> {advertiserData?.business_industry}
          </Typography>
        </Box>

        {/* Business Category */}
        <Box sx={{ display: "flex", alignItems: "center", mb: 1, gap: 1 }}>
          <MdCategory color="#2E4053" size={20} />
          <Typography>
            <strong>Category:</strong> {advertiserData?.business_category}
          </Typography>
        </Box>
        {/* Always editable */}
        <TextField
          label="Target Industries (comma separated)"
          name="target_industries"
          value={form.target_industries}
          onChange={handleChange}
          fullWidth
          sx={{ mb: 2 }}
        />
        <TextField
          label="Target Categories (comma separated)"
          name="target_categories"
          value={form.target_categories}
          onChange={handleChange}
          fullWidth
          sx={{ mb: 2 }}
        />

        {/* Balance */}
        <Box
          sx={{
            mt: 2,
            p: 2,
            backgroundColor: "#F0F4FF",
            borderRadius: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              color: "#2E4053",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <FaMoneyBillWave /> Account Balance
          </Typography>

          {/* // TODO :currency */}
          {/* Display balance */}
          <Chip
            label={`$${advertiserData?.account_balance || 0}`}
            color="primary"
            sx={{
              fontWeight: "bold",
              fontSize: "16px",
              backgroundColor: "#EA6A12",
              color: "#fff",
              px: 2,
              py: 1,
              opacity: editing ? 0.5 : 1, // visually indicate disabled
              pointerEvents: editing ? "none" : "auto", // disable click while editing
            }}
          />

          {/* Optional charge button */}
          <Button
            variant="contained"
            color="secondary"
            disabled={editing} // disable while editing
            onClick={handleCharge}
            sx={{ ml: 2 }}
          >
            Charge
          </Button>
        </Box>

        <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
          {/* Submit button */}
          <Button
            variant="contained"
            onClick={handleSubmit}
            sx={{
              backgroundColor: "#2E4053",
              color: "#fff",
              fontWeight: "bold",
              fontSize: "16px",
              borderRadius: "8px",
              padding: "12px 24px",
              "&:hover": { backgroundColor: "#1C2A3D" },
            }}
          >
            {isAdvertiser ? "Update Advertiser" : "Create Advertiser"}
          </Button>

          {/* Cancel button, only show while editing */}
          {editing && (
            <Button
              variant="outlined"
              onClick={() => setEditing(false)} // close edit mode
              sx={{
                backgroundColor: "#fff",
                color: "#EA6A12",
                fontWeight: "bold",
                fontSize: "16px",
                borderRadius: "8px",
                borderColor: "#EA6A12",
                padding: "12px 24px",
                "&:hover": {
                  backgroundColor: "#FDF2E9",
                  borderColor: "#EA6A12",
                },
              }}
            >
              Cancel
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Advertiser;
